import { render, staticRenderFns } from "./QuestionDetail.vue?vue&type=template&id=14470830&scoped=true&"
import script from "./QuestionDetail.vue?vue&type=script&lang=js&"
export * from "./QuestionDetail.vue?vue&type=script&lang=js&"
import style0 from "./QuestionDetail.vue?vue&type=style&index=0&id=14470830&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14470830",
  null
  
)

export default component.exports